/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkContact } from '../models/work-contact';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkProject } from '../models/work-project';
import { WorkSearchResultContactDto } from '../models/work-search-result-contact-dto';

@Injectable({ providedIn: 'root' })
export class WorkContactsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `contactsV1ControllerFindAll()` */
  static readonly ContactsV1ControllerFindAllPath = '/v1/contacts';

  /**
   * Required permissions: contacts:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV1ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV1ControllerFindAll$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 20
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by id query param.
     *           <p>
     *              <b>Format: </b> filter.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.id=$not:$like:John Doe&filter.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$in</li></ul>
     */
      'filter.id'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC'>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkContact>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'id'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsService.ContactsV1ControllerFindAllPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.id', params['filter.id'], {});
      rb.query('sortBy', params.sortBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkContact>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'id'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: contacts:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV1ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV1ControllerFindAll(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 20
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by id query param.
     *           <p>
     *              <b>Format: </b> filter.id={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.id=$not:$like:John Doe&filter.id=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$in</li></ul>
     */
      'filter.id'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC'>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkContact>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'id'?: (string | Array<string>);
};
};
}> {
    return this.contactsV1ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkContact>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'id'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkContact>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'id'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `contactsV1ControllerSearch()` */
  static readonly ContactsV1ControllerSearchPath = '/v1/contacts/search/{keyword}';

  /**
   * Required permissions: contacts:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV1ControllerSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV1ControllerSearch$Response(
    params: {
      keyword: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkSearchResultContactDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsService.ContactsV1ControllerSearchPath, 'get');
    if (params) {
      rb.path('keyword', params.keyword, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkSearchResultContactDto>>;
      })
    );
  }

  /**
   * Required permissions: contacts:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV1ControllerSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV1ControllerSearch(
    params: {
      keyword: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkSearchResultContactDto>> {
    return this.contactsV1ControllerSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkSearchResultContactDto>>): Array<WorkSearchResultContactDto> => r.body)
    );
  }

  /** Path part for operation `contactsV1ControllerFindOne()` */
  static readonly ContactsV1ControllerFindOnePath = '/v1/contacts/{id}';

  /**
   * Required permissions: contacts:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV1ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV1ControllerFindOne$Response(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkContact>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsService.ContactsV1ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkContact>;
      })
    );
  }

  /**
   * Required permissions: contacts:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV1ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV1ControllerFindOne(
    params: {
      id: string;
    },
    context?: HttpContext
  ): Observable<WorkContact> {
    return this.contactsV1ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkContact>): WorkContact => r.body)
    );
  }

  /** Path part for operation `contactsV1ControllerFindProjects()` */
  static readonly ContactsV1ControllerFindProjectsPath = '/v1/contacts/{id}/projects';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactsV1ControllerFindProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV1ControllerFindProjects$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProject>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkContactsService.ContactsV1ControllerFindProjectsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProject>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `contactsV1ControllerFindProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contactsV1ControllerFindProjects(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkProject>> {
    return this.contactsV1ControllerFindProjects$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProject>>): Array<WorkProject> => r.body)
    );
  }

}
